<template>
	<div>
		<!-- eslint-disable-next-line vue/no-mutating-props -->
		<v-dialog v-if="coolDialog" v-model="coolDialog" :max-width="size === 'sm' ? 295 : 364" :retain-focus="false" persistent>
			<div :class="`${theme}-theme`" @click="cancelEvent" @dblclick="cancelEvent">
				<div class="popup pa-0">
					<div class="popup-header pa-0 text-center">
						<div class="text-right pa-1">
						</div>
						<h4 class="fs--14 fw--600 popup-header-text cooldown">
							{{ viewerDisplayName }} SLAPPED A <br />
							{{ sticker.name }} STICKER FOR {{ stickerBits }} Bits
						</h4>
					</div>
					<div class="popup-body">
						<div class="popup-content">
							<template v-if="sticker.stickerType === 'TTS'">
								<AssetsTTS :sticker="sticker" :list="false" :popupMd="true" />
							</template>
							<template v-else>
								<v-img :src="getStickerImagePath(sticker)" width="100%" contain height="100"></v-img>
							</template>

							<p class="fs--12 mt-3 fw--800 popup-footer-text">{{ popupFooterText }}</p>
							<h1 class="fs--30 fw--600 mt-8 mb-3 popup-footer-text">{{ time }}</h1>
						</div>
					</div>
				</div>
			</div>
		</v-dialog>
	</div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import { useStore } from '@/store';
import { StickerType } from '@/utils/constants';
import { getStickerImagePath } from '@/utils/utils';
import { mdiClose } from '@mdi/js';
import AssetsTTS from '@/components/panel/Stickers/AssetsTTS.vue';

export default {
	components: {
		AssetsTTS,
	},
	props: {
		coolDialog: {
			type: Boolean,
			default: false,
		},
		sticker: Object,
	},
	emits: ['onClose'],
	setup(props, ctx) {
		const store = useStore();

		// Load cooldown values.
		const timer = ref(null);
		const time = ref(0);
		if (!store.state.isPartyModeOn) {
			time.value = store.state.cooldownTime;
		} else {
			time.value = store.state.partyModeCooldownTime;
		}

		const theme = computed(() => store.state.theme);
		const size = computed(() => store.state.size);
		const viewerDisplayName = computed(() => store.state.viewerDisplayName);

		const stickerBits = computed(() => {
			if (!store.state.isPartyModeOn) {
				return props.sticker.bits;
			} else {
				return 0;
			}
		});

		// We show a different footer message for TTS stickers where the streamer manually approves.
		const popupFooterText = computed(() => {
			if (props.sticker.stickerType == StickerType.TTS && store.state.ttsIsManuallyApproveAllStickers) {
				return 'Your TTS message has been sent to the moderation queue. It will only be shown if approved by the broadcaster.';
			} else {
				return 'Please wait...!!!';
			}
		});

		onMounted(() => {
			setTimer();
		});

		const setTimer = () => {
			timer.value = setInterval(() => {
				if (time.value > 0) {
					time.value--;
				} else {
					clearTimer();
				}
			}, 1000);
		};

		const clearTimer = () => {
			clearInterval(timer.value);
			close();
		};

		const close = () => {
			ctx.emit('onClose');
		};

		const cancelEvent = event => {
			event.stopImmediatePropagation();
		};

		return {
			theme,
			size,
			time,
			close,
			cancelEvent,
			getStickerImagePath,
			viewerDisplayName,
			stickerBits,
			popupFooterText,
			icons: {
				mdiClose,
			},
		};
	},
};
</script>
